import { ecrireJson, lireJson, type Resultat } from './client';

/** Ce que le lien de réinitialisation propose, avant d'être consommé. */
export interface ApercuReinitialisation {
  readonly emailMasque: string;
  readonly expireLe: string;
}

/** Lien fabriqué par un administrateur — rendu UNE seule fois. */
export interface LienReinitialisation {
  readonly email: string;
  readonly expireLe: string;
  readonly jeton: string;
  readonly lien: string;
}

/**
 * Demande un lien (public). Le serveur répond toujours pareil, que l'adresse
 * existe ou non : c'est lui qui décide, l'écran ne devine pas.
 */
export function demanderReinitialisation(
  email: string,
  options: { fetchImpl?: typeof fetch } = {},
): Promise<Resultat<null>> {
  return ecrireJson<null>('/api/auth/mot-de-passe/demande', 'POST', { email }, options);
}

export function verifierLienMotDePasse(
  jeton: string,
  options: { fetchImpl?: typeof fetch; signal?: AbortSignal } = {},
): Promise<Resultat<ApercuReinitialisation>> {
  return lireJson<ApercuReinitialisation>(
    `/api/auth/mot-de-passe/${encodeURIComponent(jeton)}`,
    options,
  );
}

export function definirMotDePasse(
  jeton: string,
  motDePasse: string,
  options: { fetchImpl?: typeof fetch } = {},
): Promise<Resultat<{ utilisateur: unknown }>> {
  return ecrireJson<{ utilisateur: unknown }>(
    `/api/auth/mot-de-passe/${encodeURIComponent(jeton)}`,
    'POST',
    { mot_de_passe: motDePasse },
    options,
  );
}

/** Changement par le titulaire : l'ancien mot de passe est exigé. */
export function changerMotDePasse(
  ancien: string,
  nouveau: string,
  options: { fetchImpl?: typeof fetch } = {},
): Promise<Resultat<{ utilisateur: unknown }>> {
  return ecrireJson<{ utilisateur: unknown }>(
    '/api/auth/mot-de-passe/change',
    'PUT',
    { ancien, nouveau },
    options,
  );
}

/** Fabrique un lien pour un compte (réservé à l'administrateur). */
export function creerLienReinitialisation(
  compteId: string,
  options: { fetchImpl?: typeof fetch } = {},
): Promise<Resultat<LienReinitialisation>> {
  return ecrireJson<LienReinitialisation>(
    `/api/admin/comptes/${encodeURIComponent(compteId)}/reinitialisation`,
    'POST',
    {},
    options,
  );
}
